<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'ShadowBackground'
});
</script>

<template>
  <div class="shadow"></div>
</template>

<style scoped>
.shadow {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0, 0.6);
}
</style>
